import { useAuth } from "@/store/auth";

/**
 * Returns `true` when the session has a real instance bound (not bootstrap
 * mode). Use to gate `useQuery({ enabled })` on instance-dependent queries so
 * they don't fire (and 400) when no instance is selected yet.
 */
export function useHasInstance(): boolean {
  return useAuth((s) => s.instance !== null);
}
